import { Typography, TypographyProps } from "@mui/material";
import React from "react";
import { CONSTANTS } from "../../CONSTANTS";

type TextLabelProps = {
    type: 'title'
        | 'titleRegular'
        | 'tabHeader'
        | 'tableHeader'
        | 'smallText'
        | 'smallLinkText'
        | 'regularText'
        | 'bluButtonText'
        | 'buttonText'
        | 'errorText'
        | 'labelText';
    children: React.ReactNode;
    sxStyles?: React.CSSProperties;
} & TypographyProps

const TextLabel = ({ type, children, sxStyles = {}, ...props }: TextLabelProps): JSX.Element => {

    switch (type) {
      case "title":
        return (
          <>
            <Typography
              color={CONSTANTS.COLORS.TEXT_BLACK}
              sx={{
                fontSize: 18,
                fontWeight: 600,
                fontFamily: "Inter",
                ...sxStyles,
              }}
              {...props}
            >
              {children}
            </Typography>
          </>
        );

      case "titleRegular":
        return (
          <>
            <Typography
              color={CONSTANTS.COLORS.TEXT_BLACK}
              sx={{
                fontSize: 18,
                fontWeight: 400,
                fontFamily: "Inter",
                ...sxStyles,
              }}
              {...props}
            >
              {children}
            </Typography>
          </>
        );

      case "tabHeader":
        return (
          <>
            <Typography
              color={CONSTANTS.COLORS.TEXT_BLACK}
              sx={{
                fontSize: 16,
                fontWeight: 400,
                fontFamily: "Inter",
                ...sxStyles,
              }}
              {...props}
            >
              {children}
            </Typography>
          </>
        );

      case "tableHeader":
        return (
          <>
            <Typography
              color={CONSTANTS.COLORS.TEXT_BLACK}
              sx={{
                fontSize: 14,
                fontWeight: 600,
                fontFamily: "Inter",
                ...sxStyles,
              }}
              {...props}
            >
              {children}
            </Typography>
          </>
        );

      case "smallText":
        return (
          <>
            <Typography
              color={CONSTANTS.COLORS.TEXT_BLACK}
              variant="body2"
              sx={{
                fontSize: 12,
                fontWeight: 400,
                fontFamily: "Inter",
                ...sxStyles,
              }}
              {...props}
            >
              {children}
            </Typography>
          </>
        );

      case "smallLinkText":
        return (
          <>
            <Typography
              color={CONSTANTS.COLORS.TEXT_BLACK}
              variant="body2"
              sx={{
                fontSize: 12,
                fontWeight: 600,
                fontFamily: "Inter",
                ...sxStyles,
              }}
              {...props}
            >
              {children}
            </Typography>
          </>
        );

      case "bluButtonText":
        return (
          <>
            <Typography
              color={CONSTANTS.COLORS.BTN_TEXT_BLUE}
              variant="body2"
              sx={{
                fontSize: 14,
                fontWeight: 400,
                alignContent: "center",
                fontFamily: "Arial",
                ...sxStyles,
              }}
              {...props}
            >
              {children}
            </Typography>
          </>
        );

      case "buttonText":
        return (
          <>
            <Typography
              color={CONSTANTS.COLORS.TEXT_WHITE}
              variant="body2"
              sx={{
                fontSize: 12,
                fontWeight: 400,
                fontFamily: "Arial",
                ...sxStyles,
              }}
              {...props}
            >
              {children}
            </Typography>
          </>
        );

      case "labelText":
        return (
          <>
            <Typography
              color={CONSTANTS.COLORS.LABEL_GREY}
              variant="body2"
              sx={{
                fontSize: 12,
                fontWeight: 400,
                fontFamily: "Arial",
                ...sxStyles,
              }}
              {...props}
            >
              {children}
            </Typography>
          </>
        );

      case "errorText":
        return (
          <>
            <Typography
              color={CONSTANTS.COLORS.ERROR_RED}
              variant="body2"
              sx={{
                fontSize: "0.75rem",
                fontWeight: 400,
                fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                marginLeft: "14px",
                marginRight: "14px",
                marginTop: "3px",
                ...sxStyles,
              }}
              {...props}
            >
              {children}
            </Typography>
          </>
        );

      default:
        return (
          <>
            <Typography
              color={CONSTANTS.COLORS.TEXT_BLACK}
              sx={{
                fontSize: 14,
                fontWeight: 400,
                fontFamily: "Inter",
                ...sxStyles,
              }}
              {...props}
            >
              {children}
            </Typography>
          </>
        );
    }

   
}

export default TextLabel;